import {
  InsuranceCitizenship,
  InsuranceParticipantData,
  InsurancePolicyholderData,
} from '../../../model/types'

import { InsurancePersonTarget } from './person-target'

export const applyCitizenship = (
  target: InsurancePersonTarget,
  citizenship: InsuranceCitizenship,
  policyholder: InsurancePolicyholderData,
  participants: InsuranceParticipantData[],
) => {
  if (target.person === 'policyholder') {
    return {
      policyholder: { ...policyholder, citizenship },
      participants,
    }
  }

  const updatedParticipants = [...participants]

  updatedParticipants[target.participantIndex] = {
    ...updatedParticipants[target.participantIndex],
    citizenship,
  }

  return { policyholder, participants: updatedParticipants }
}
